import styled from "styled-components";
import { device } from "../../../stylesheet/breakpoints";

export const Container = styled.div`
  width: 100%;
  text-align: start;

  @media ${device.desktop} {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: calc(100% - 200px);
  }
`;

type Props = {
  value: number;
};

export const Circle = styled.div<Props>`
  position: relative;
  width: 32px;
  height: 32px;
  margin-right: 7px;
  border-radius: 50%;
  background-color: var(--article-bg);
  overflow: hidden;
  background-image: conic-gradient(
    var(--bg-button) ${({ value }) => value + "%"},
    var(--article-bg) 0
  );

  &::before {
    content: "";
    position: absolute;
    top: 8px;
    left: 8px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: var(--bg-color);
  }
`;

export const Loader = styled.div`
  animation: p 5s steps(100) infinite;
  font-weight: 400;
  font-size: 10px;
  line-height: 1.2;
  left: 0;
  color: var(--text-color);

  & span {
    font-weight: 700;
    color: var(--bg-button);
  }
`;
